import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { UserState } from "./types";
import { persistReducer } from "redux-persist";
import { User as UserType } from "@/types";
import storage from "redux-persist/lib/storage";

export const initialState: UserState = {
  data: null,
  isAuthenticated: false,
  loading: false,
  error: null,
  accountId: null,
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    loginSuccess: (state: UserState, action: PayloadAction<UserType>) => {
      state.isAuthenticated = true;
      state.data = action.payload;
    },
    loginFailure: (state: UserState) => {
      state.isAuthenticated = false;
    },
    logout: (state: UserState) => {
      state.loading = false;
      state.isAuthenticated = false;
      state.data = null;
    },
    fetchUser: (state: UserState) => {
      state.loading = true;
      state.error = null;
    },
    setUser: (state: UserState, action: PayloadAction<UserType>) => {
      state.isAuthenticated = true;
      state.data = action.payload;
      state.loading = false;
      state.error = null;
    },
    setError: (state: UserState, action: PayloadAction<string>) => {
      state.isAuthenticated = false;
      state.error = action.payload;
      state.loading = false;
    },
    setAccountId: (state: UserState, action: PayloadAction<string>) => {
      state.accountId = action.payload;
    },
  },
});

const persistConfig = {
  key: "user",
  storage,
  whitelist: ["isAuthenticated"],
};

export const {
  fetchUser,
  setUser,
  setError,
  loginSuccess,
  loginFailure,
  logout,
  setAccountId,
} = userSlice.actions;

export const userReducer = userSlice;
export default persistReducer(persistConfig, userSlice.reducer);
